import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject
} from '@angular/core';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-loading-mask',
  templateUrl: './loading-mask.component.html',
  styleUrls: ['./loading-mask.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoadingMaskComponent implements OnInit {
  loadingService = inject(LoadingService);

  ngOnInit(): void {}
}
